import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchFilterSectionView } from "@/components/Search/SearchFilterSectionView";
import { SearchPageWrapper } from "@/components/Search/index";
import { useSearchFilterHandler } from "@/components/Search/useSearchFilterHandler";
import { useSearchPageData } from "@/components/Search/useSearchPageData";
import { useMobileFilterSideSheet } from "@/hooks/useMobileFilterSideSheet";
import { useScrollPosition } from "../../utils/scroll";
import { SearchProductListView } from "./SearchProductListView";
export const ProductSearchListPage = (param)=>{
    let {} = param;
    const { handleSortFilter , handleResetFilter , handleSubjectFilter , handleDetailFilter , handleKeywordFilter , isCheckFilterItem , isCheckFilterCount , selectedFilterList , hasSelectedFilter , handleSolvookPassesFilter , filterParams  } = useSearchFilterHandler();
    const { subjectTabList , sortList , listData , hasNextPage , isFetchingNextPage , isLoading , newFilterList , keywordFilterList , hasFilterItems , totalCount , emptyStatus , bottom , hasSolvookPassesFilter  } = useSearchPageData({
        filterParams,
        selectedFilterList
    });
    useScrollPosition("searchListPage");
    const { mobileFilterSideSheet , handleMobileSideSheet  } = useMobileFilterSideSheet();
    return /*#__PURE__*/ _jsxs(SearchPageWrapper, {
        children: [
            /*#__PURE__*/ _jsx(SearchFilterSectionView, {
                subjectTabList: subjectTabList,
                filterParams: filterParams,
                handleSubjectFilter: handleSubjectFilter,
                handleDetailFilter: handleDetailFilter,
                handleKeywordFilter: handleKeywordFilter,
                handleSortFilter: handleSortFilter,
                handleResetFilter: handleResetFilter,
                handleSolvookPassesFilter: handleSolvookPassesFilter,
                isCheckFilterItem: isCheckFilterItem,
                isCheckFilterCount: isCheckFilterCount,
                selectedFilterList: selectedFilterList,
                newFilterList: newFilterList,
                hasSelectedFilter: hasSelectedFilter,
                mobileFilterSideSheet: mobileFilterSideSheet,
                handleMobileSideSheet: handleMobileSideSheet,
                keywordFilterList: keywordFilterList,
                hasFilterItems: hasFilterItems,
                totalCount: totalCount,
                hasSolvookPassesFilter: hasSolvookPassesFilter,
                sortList: sortList
            }),
            /*#__PURE__*/ _jsx(SearchProductListView, {
                list: listData,
                isLoading: isLoading,
                isFetchingNextPage: isFetchingNextPage,
                hasNextPage: hasNextPage,
                emptyStatus: emptyStatus
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: bottom
            })
        ]
    });
};
